export const url = {
    home: () => '/',

    catalog: () => '/package/catalog',

    category: (category) => `/package/catalog/${category.slug}`,

    product: (product) => `/shop/products/${product.slug}`,
};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}
